module.exports = __webpack_public_path__ + "static/banner-53625a2524008fe2f54644013fa2ee66.png";